import { ChevronUp, ChevronDown } from 'lucide-react'

export default function VoteButtons({ score, userVote, onVote }) {
  return (
    <div className="flex flex-col items-center gap-0.5 w-9">
      <button
        type="button"
        onClick={() => onVote(1)}
        className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all ${
          userVote === 1
            ? 'bg-primary text-primary-foreground shadow-sm'
            : 'hover:bg-secondary text-muted-foreground hover:text-foreground'
        }`}
      >
        <ChevronUp className="w-4 h-4" strokeWidth={2.5} />
      </button>
      <span
        className={`font-bold text-sm tabular-nums ${
          score > 0 ? 'text-emerald-600' : score < 0 ? 'text-red-500' : 'text-muted-foreground'
        }`}
      >
        {score}
      </span>
      <button
        type="button"
        onClick={() => onVote(-1)}
        className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all ${
          userVote === -1
            ? 'bg-red-100 text-red-600 shadow-sm'
            : 'hover:bg-secondary text-muted-foreground hover:text-foreground'
        }`}
      >
        <ChevronDown className="w-4 h-4" strokeWidth={2.5} />
      </button>
    </div>
  )
}
